module.exports = __webpack_public_path__ + "4b15b19c5dddce3009dc379d8d3ea13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/eva_vitija.jpg
// module id = 111
// module chunks = 0